import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import React, { Component } from 'react';
import Text from "react-native-web/dist/exports/Text";
import View from "react-native-web/dist/exports/View";
import Calendar from "../calendar";
import styleConstructor from "./style";
import { jsx as ___EmotionJSX } from "@emotion/core";

var CalendarListItem = function (_Component) {
  _inherits(CalendarListItem, _Component);

  var _super = _createSuper(CalendarListItem);

  function CalendarListItem(props) {
    var _this;

    _classCallCheck(this, CalendarListItem);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onPressArrowLeft", function (_, month) {
      var monthClone = month.clone();

      if (_this.props.onPressArrowLeft) {
        _this.props.onPressArrowLeft(_, monthClone);
      } else if (_this.props.scrollToMonth) {
        var currentMonth = monthClone.getMonth();
        monthClone.addMonths(-1);

        while (monthClone.getMonth() === currentMonth) {
          monthClone.setDate(monthClone.getDate() - 1);
        }

        _this.props.scrollToMonth(monthClone);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onPressArrowRight", function (_, month) {
      var monthClone = month.clone();

      if (_this.props.onPressArrowRight) {
        _this.props.onPressArrowRight(_, monthClone);
      } else if (_this.props.scrollToMonth) {
        monthClone.addMonths(1);

        _this.props.scrollToMonth(monthClone);
      }
    });

    _this.style = styleConstructor(props.theme);
    return _this;
  }

  _createClass(CalendarListItem, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var r1 = this.props.item;
      var r2 = nextProps.item;
      return r1.toString('yyyy MM') !== r2.toString('yyyy MM') || !!(r2.propbump && r2.propbump !== r1.propbump);
    }
  }, {
    key: "render",
    value: function render() {
      var row = this.props.item;

      if (row.getTime) {
        return ___EmotionJSX(Calendar, {
          testID: this.props.testID + "_" + row,
          theme: this.props.theme,
          style: [{
            height: this.props.calendarHeight,
            width: this.props.calendarWidth
          }, this.style.calendar, this.props.style],
          current: row,
          hideArrows: this.props.hideArrows,
          hideExtraDays: this.props.hideExtraDays,
          disableMonthChange: true,
          markedDates: this.props.markedDates,
          markingType: this.props.markingType,
          hideDayNames: this.props.hideDayNames,
          onDayPress: this.props.onDayPress,
          onDayLongPress: this.props.onDayLongPress,
          displayLoadingIndicator: this.props.displayLoadingIndicator,
          minDate: this.props.minDate,
          maxDate: this.props.maxDate,
          firstDay: this.props.firstDay,
          monthFormat: this.props.monthFormat,
          dayComponent: this.props.dayComponent,
          disabledByDefault: this.props.disabledByDefault,
          showWeekNumbers: this.props.showWeekNumbers,
          renderArrow: this.props.renderArrow,
          onPressArrowLeft: this.props.horizontal ? this.onPressArrowLeft : this.props.onPressArrowLeft,
          onPressArrowRight: this.props.horizontal ? this.onPressArrowRight : this.props.onPressArrowRight,
          headerStyle: this.props.horizontal ? this.props.headerStyle : undefined,
          accessibilityElementsHidden: this.props.accessibilityElementsHidden,
          importantForAccessibility: this.props.importantForAccessibility,
          renderHeader: this.props.renderHeader
        });
      } else {
        var text = row.toString();
        return ___EmotionJSX(View, {
          style: [{
            height: this.props.calendarHeight,
            width: this.props.calendarWidth
          }, this.style.placeholder]
        }, ___EmotionJSX(Text, {
          allowFontScaling: false,
          style: this.style.placeholderText
        }, text));
      }
    }
  }]);

  return CalendarListItem;
}(Component);

_defineProperty(CalendarListItem, "displayName", 'IGNORE');

_defineProperty(CalendarListItem, "defaultProps", {
  hideArrows: true,
  hideExtraDays: true
});

export default CalendarListItem;

if (typeof CalendarListItem !== 'undefined' && CalendarListItem && CalendarListItem === Object(CalendarListItem) && Object.isExtensible(CalendarListItem) && !CalendarListItem.hasOwnProperty('__filemeta')) {
  Object.defineProperty(CalendarListItem, '__filemeta', {
    configurable: true,
    value: {
      name: "CalendarListItem",
      filename: "node_modules/react-native-calendars/src/calendar-list/item.js"
    }
  });
}